import { render, staticRenderFns } from "./leaders.pug?vue&type=template&id=ac53ea4c&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./leaders.scss?vue&type=style&index=0&id=ac53ea4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac53ea4c",
  null
  
)

export default component.exports